<ng-container>
  <ng-container *ngFor="let dataType of cellData.dataType; let i = index">
    <ng-container *ngIf="cellData.values[i] == '-' && dataType !== 'WATCHLIST'">
      <ng-container *ngIf="dataType === 'TEXT'">
        <div class="text-left tdDataSize">-</div>
      </ng-container>
      <ng-container *ngIf="dataType === 'NUMBER'">
        <div class="text-right tdDataSize">0</div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="cellData.values[i] != '-'">
      <ng-container *ngIf="dataType == 'NUMBER'">
        <div class="text-right tdDataSize">{{ cellData.values[i] | number }}</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'ALPHANUMERIC'">
        <div class="text-right tdDataSize">{{ cellData.values[i]}}</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'TEXT'">
        <div class="text-left tdDataSize">{{ cellData.values[i] }}</div>
      </ng-container>
      <!-- <ng-container *ngIf="dataType == 'OPTIONS'">
        <div class="text-center tdDataSize" [autoClose]="true" triggers="manual" #p="ngbPopover"
          placement="bottom-right" (click)="p.open()" [ngbPopover]="popContent"><i class="fas fa-ellipsis-v"></i>
        </div>
      </ng-container> -->

      <ng-container *ngIf="dataType == 'OPTIONS'">
        <!-- <div class="text-center tdDataSize" [autoClose]="true" triggers="manual" #p="ngbPopover"
          placement="bottom-right" (click)="p.open()" [ngbPopover]="popContent"><i class="fas fa-ellipsis-v"></i>
        </div> -->
        
        <div class="button-table d-flex gap-2">
          <ng-container *ngFor="let val of cellData.values[i]">
            <button *ngIf="val == 'Read' || val == 'Read_Self'" mat-icon-button color="primary"
              (click)="handleOptionClick('View', cellData)"><mat-icon>visibility</mat-icon></button>
            <button *ngIf="val == 'Edit'" mat-icon-button color="primary"
              (click)="handleOptionClick('Edit', cellData)"><mat-icon>edit</mat-icon></button>
            <button *ngIf="val == 'Edit'" mat-icon-button color="warn"
              (click)="handleOptionClick('Delete', cellData)"><mat-icon>delete</mat-icon></button>
          </ng-container>
        </div>

      </ng-container>


      <ng-container *ngIf="dataType == 'PERCENTAGE'">
        <div class="text-right tdDataSize"> {{ cellData.values[i] }}%</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'DATE'">
        <div class="text-right tdDataSize"> {{ cellData.values[i] | date }}</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'LOCATION'">
        <div *ngIf="!isTotalData" class="text-left link tdDataSize" (click)="click(cellData)"> {{ cellData.values[i] |
          uppercase }}</div>
        <div *ngIf="isTotalData" class="text-left tdDataSize">{{ cellData.values[i] | uppercase }}</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'FINALLOCATION'">
        <div class="text-left tdDataSize"> {{ cellData.values[i].value }} </div>
      </ng-container>
      <ng-container *ngIf="dataType == 'POPUP'">
        <div *ngIf="!isTotalData" class="text-center link tdDataSize" (click)="popupCalled(cellData)"> {{
          cellData.values[i] }}</div>
        <div *ngIf="isTotalData" class="text-center tdDataSize">{{ cellData.values[i].value }}</div>
      </ng-container>
      <ng-container *ngIf="dataType == 'CHECKBOX'">
        <div class="text-center tdDataSize"><input type="checkbox" name="singleCheck" [checked]="cellData.values[i]"
            [(ngModel)]="cellData.values[i]">
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="dataType == 'WATCHLIST'">
      <div class="text-center tdDataSize"><i class="gpicon-flag"
          [ngClass]="(cellData.values[i])?'orange-color':'grey-color'" (click)="handleWatchlistClick(cellData)"></i>
      </div>
    </ng-container>
    <!-- <ng-template #popContent>
      <ul class="list-group" *ngFor="let val of cellData.values[i]">
        <li class="list-group-item list-css" (click)="handleOptionClick(val, cellData); selectedOption(val,cellData)">
          {{val}}</li>
      </ul>
    </ng-template> -->
  </ng-container>
</ng-container>